export default __webpack_public_path__ + "static/media/logo.bf6b2e25.svg";